var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdCard = function SvgIdCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 69 68"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#idCard_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 3.996,
    y: 4,
    fill: "#F2F7FF",
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#idCard_svg__b)",
    d: "m16.366 13.479 35.783.244c3.374.023 6.09 2.41 6.09 5.353l-.004 41.166c0 2.942-2.717 5.293-6.091 5.27l-35.783-.244c-3.375-.023-6.09-2.41-6.09-5.353l.004-41.166c0-2.942 2.717-5.293 6.091-5.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.948 36.4c0 1.369-.277 2.723-.814 3.984a10.3 10.3 0 0 1-2.318 3.366 10.6 10.6 0 0 1-3.468 2.237 10.9 10.9 0 0 1-4.091.765 11 11 0 0 1-4.091-.821 10.8 10.8 0 0 1-3.468-2.284 10.5 10.5 0 0 1-2.317-3.398 10.2 10.2 0 0 1-.814-3.995c0-1.37.277-2.723.814-3.984a10.3 10.3 0 0 1 2.318-3.367 10.6 10.6 0 0 1 3.469-2.236 10.9 10.9 0 0 1 4.09-.766c1.405.01 2.795.289 4.092.822a10.8 10.8 0 0 1 3.468 2.283 10.5 10.5 0 0 1 2.317 3.398c.537 1.269.813 2.627.813 3.996"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3982DD",
    d: "M34.257 31.256A4.2 4.2 0 0 0 31.3 32.43a4 4 0 0 0-1.225 2.876c0 .602.137 1.198.4 1.745.264.546.649 1.03 1.126 1.416a9.4 9.4 0 0 0-3.258 1.656 9.1 9.1 0 0 0-2.34 2.76 10.8 10.8 0 0 0 3.688 2.832 11 11 0 0 0 4.565 1.033c1.578.01 3.137-.321 4.564-.97a10.56 10.56 0 0 0 3.69-2.781 9.3 9.3 0 0 0-2.34-2.795 9.5 9.5 0 0 0-3.26-1.703 4.06 4.06 0 0 0 1.126-1.399 4 4 0 0 0 .403-1.737c0-1.082-.44-2.122-1.225-2.892a4.26 4.26 0 0 0-2.957-1.215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.06 50.597c-.287-.002-.564.196-.767.549s-.319.834-.319 1.335c0 .502.115.983.318 1.34.204.356.48.557.768.559l22.392.152c.288.002.565-.195.768-.548s.318-.834.318-1.335c0-.502-.114-.984-.317-1.34s-.48-.557-.768-.56zM28.302 56.934c-.307-.002-.6.195-.817.548s-.339.833-.339 1.335.122.983.338 1.34c.217.356.51.557.817.56l11.911.08c.306.003.6-.195.817-.548s.338-.833.338-1.335-.121-.983-.338-1.34c-.216-.356-.51-.557-.817-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#idCard_svg__c)",
    d: "M30.044 2.3c-1.78-.013-3.212 1.374-3.212 3.11l-.002 14.16 14.855.102.002-14.161c0-1.735-1.432-3.142-3.212-3.154z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.582,
    d: "m26.549 20.234 15.417.105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.428 10.37c0 .405-.082.807-.241 1.18a3.1 3.1 0 0 1-.688 1c-.294.284-.644.51-1.028.662a3.252 3.252 0 0 1-2.426-.017 3.2 3.2 0 0 1-1.03-.677 3.1 3.1 0 0 1-.686-1.007 3.032 3.032 0 0 1 .688-3.364 3.2 3.2 0 0 1 2.241-.891c.84.006 1.647.337 2.242.92.594.585.928 1.373.928 2.193"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#idCard_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#idCard_svg__e)",
    d: "m16.374 13.479 35.783.244c3.374.023 6.09 2.41 6.09 5.353l-.004 41.166c0 2.942-2.717 5.293-6.092 5.27l-35.782-.244c-3.375-.023-6.091-2.41-6.09-5.353l.004-41.166c0-2.942 2.717-5.293 6.09-5.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.956 36.4c0 1.369-.277 2.723-.814 3.984a10.3 10.3 0 0 1-2.318 3.366 10.6 10.6 0 0 1-3.469 2.237 10.9 10.9 0 0 1-4.09.765 11 11 0 0 1-4.092-.821 10.8 10.8 0 0 1-3.468-2.284 10.5 10.5 0 0 1-2.317-3.398 10.2 10.2 0 0 1-.813-3.995c0-1.37.277-2.723.814-3.984a10.3 10.3 0 0 1 2.318-3.367 10.6 10.6 0 0 1 3.468-2.236 10.9 10.9 0 0 1 4.092-.766c1.403.01 2.793.289 4.09.822a10.8 10.8 0 0 1 3.468 2.283 10.5 10.5 0 0 1 2.317 3.398 10.2 10.2 0 0 1 .814 3.996"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3982DD",
    d: "M34.265 31.256a4.2 4.2 0 0 0-2.957 1.174 4 4 0 0 0-1.225 2.876c0 .602.137 1.198.4 1.745.264.546.649 1.03 1.126 1.416a9.4 9.4 0 0 0-3.258 1.656 9.1 9.1 0 0 0-2.34 2.76 10.8 10.8 0 0 0 3.688 2.832 11 11 0 0 0 4.565 1.033c1.578.01 3.137-.321 4.564-.97a10.56 10.56 0 0 0 3.69-2.781 9.3 9.3 0 0 0-2.34-2.795 9.5 9.5 0 0 0-3.26-1.703 4.06 4.06 0 0 0 1.126-1.399 4 4 0 0 0 .403-1.737c0-1.082-.44-2.122-1.225-2.892a4.26 4.26 0 0 0-2.957-1.215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#idCard_svg__f)",
    d: "M30.052 2.3c-1.78-.013-3.212 1.374-3.212 3.11l-.002 14.16 14.855.102.002-14.161c0-1.735-1.433-3.142-3.212-3.154z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.582,
    d: "m26.557 20.234 15.417.105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.436 10.37c0 .405-.082.807-.242 1.18a3.1 3.1 0 0 1-.687 1 3.2 3.2 0 0 1-1.029.662 3.251 3.251 0 0 1-2.426-.017 3.2 3.2 0 0 1-1.028-.677 3.1 3.1 0 0 1-.687-1.007 3.033 3.033 0 0 1 .687-3.364 3.2 3.2 0 0 1 2.242-.891c.84.006 1.647.337 2.241.92.595.585.929 1.373.929 2.193"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "idCard_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-40.50546 46.62578 -43.18276 -37.51439 54.59 17.111)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "idCard_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.017 18.86 11.075)scale(20.7472 17.822)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "idCard_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-40.50546 46.62578 -43.18276 -37.51439 54.598 17.111)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "idCard_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.017 18.863 11.077)scale(20.7472 17.822)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "idCard_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 3.996,
    y: 4,
    fill: "#fff",
    rx: 30
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "idCard_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.004 0 68.52.467-.003 36.163L0 36.163z"
  })))));
};
export default SvgIdCard;